import { rowColumn, tableOptions } from "../../../components/table/Table";
import { assignStatusPrimaryOptions, assignStatusSecondaryOptions } from "../../formObjects/application/assignStatusForm";
import { getFilterOptions } from "../../CommonFunctions";
export const applicationsListTable = (currPath: string, assessors: any): rowColumn[] => [
  {
    label: "KIS ID",
    column: "id",
    type: "string",
    allowSort: true,
    sortOn: "Id",
  },
  {
    label: "First Name",
    column: "applicationBase.child.firstName",
    type: "string",
    allowSort: true,
    sortOn: "ApplicationBase.Child.FirstName",
    isFilter: true,
    filterType: "search",
  },
  {
    label: "Last Name",
    column: "applicationBase.child.lastName",
    type: "string",
    allowSort: true,
    sortOn: "ApplicationBase.Child.LastName",
    isFilter: true,
    filterType: "search",
  },
  {
    label: "Kindergarten",
    column: "applicationBase.kindergarten.fundedKinderName",
    type: "string",
    allowSort: true,
    sortOn: "ApplicationBase.Kindergarten.FundedKinderName",
    body: (rowData) => {
      return (
        <p className="m-0">
          {rowData.applicationBase.kindergarten?.fundedKinderName === "Other"
            ? rowData.applicationBase.kindergarten?.kindergartenNameOther
            : rowData.applicationBase.kindergarten?.fundedKinderName}
        </p>
      );
    },
    isFilter: true,
    filterType: "search",
    filterKeyColumns: ["applicationBase.Kindergarten.fundedKinderName", "applicationBase.Kindergarten.kindergartenNameOther"],
  },
  {
    label: "Assigned Assessor",
    column: "applicationBase.assignAssessor.assignedAssessorName",
    type: "string",
    allowSort: true,
    sortOn: "ApplicationBase.AssignAssessor.AssignedAssessorName",
    isFilter: true,
    filterType: "multiselect",
    filterElements: assessors,
  },
  {
    label: "Status",
    column: "applicationBase.assignStatus.statusComputed",
    type: "string",
    allowSort: true,
    sortOn: "ApplicationBase.AssignStatus.StatusComputed",
    isFilter: true,
    filterType: "multiselect",
    filterElements: getFilterOptions([assignStatusPrimaryOptions.find((x) => x.value === "Application")], assignStatusSecondaryOptions, [
      { secondaryOption: "Presubmission" },
    ]),
  },
  {
    label: "Date Submitted",
    column: "applicationBase.dateSubmitted",
    type: "date",
    allowSort: true,
    sortOn: "ApplicationBase.DateSubmitted",
  },
  {
    label: "KPI",
    column: "applicationBase.kpi",
    type: "number",
    allowSort: true,
    sortOn: "ApplicationBase.KPI",
    body: (rowData) => {
      let kpiStatusColor = "";
      const kpiValue = rowData.applicationBase.kpi;
      if (kpiValue == 4 || kpiValue == 3) {
        kpiStatusColor = "kpi-status kpi-green";
      } else if (kpiValue == 2) {
        kpiStatusColor = "kpi-status kpi-yellow";
      } else if (kpiValue == 1) {
        kpiStatusColor = "kpi-status kpi-orange";
      } else if (kpiValue != null && kpiValue <= 0) {
        kpiStatusColor = "kpi-status kpi-red";
      } else {
        kpiStatusColor = "kpi-status border-transparent";
      }
      return (
        <span className={kpiValue != null ? `${kpiStatusColor}` : "kpi-status border-transparent"}>
          {kpiValue != null || kpiValue != undefined ? kpiValue : "—"}
        </span>
      );
    },
  },

  {
    label: "Actions",
    body: (rowData) => <a href={`${currPath}/${rowData.applicationBase.discriminator}/${rowData.id}`}>View Details</a>,
  },
];

export const applicationsTableOptions: tableOptions = {
  sortField: undefined,
  sortOrder: undefined,
  sortColumn: "ApplicationBase.KPI",
  sortDirection: "asc",
  filters: {
    "applicationBase.assignStatus.statusComputed": {
      searchFilter: [
        "Application - Received / awaiting check",
        "Application - Initial review in progress",
        "Application - Add Info requested",
        "Application - Add Info first reminder sent",
        "Application - Add Info second reminder sent",
        "Application - Add Info received",
        "Application - Add Info incomplete",
        "Application - Initial review complete",
        "Application - Assessor allocated",
        "Application - Withdrawn",
        "Application - Unable to process",
        "Application - Closed - Add Info not received",
        "Application - DE advice requested",
        "Application - On hold",
      ],
    },
  },
};
